import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';

import index from './modules/index';
import keepAlive from './modules/keepAlive';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    index,
    keepAlive,
  },
});

export default store;
